<script setup lang="ts">
import { ChevronRightIcon } from '@heroicons/vue/24/outline';

withDefaults(defineProps<{ number: string }>(), {
  number: '**********',
});

const emits = defineEmits<{ (e: 'restart'): void }>();

const { $t } = useNuxtApp();
const site = useSiteStore();
</script>

<template>
  <div>
    <div class="bg-layer-secondary p-4 flex flex-col gap-2 text-base-priority">
      <UserInterfaceGenericError state="info" class="w-full" full-width>
        <span class="text-xs">{{ `${$t('current-number')}: +${number}` }}</span>
      </UserInterfaceGenericError>
      <span class="text-xs">{{ $t('what-would-you-like-to-do') }}</span>
      <div
        class="bg-base rounded-lg font-bold px-2 py-2.5 flex items-center justify-between text-xs cursor-pointer"
        @click="
          site.activateModal('sumSubPasswordResetLoggedOutChangePassword')
        "
      >
        {{ $t('change-password') }}
        <ChevronRightIcon
          class="w-4 stroke-2 text-dark-900 dark:text-light-50"
        />
      </div>
      <div
        class="bg-base rounded-lg font-bold py-2.5 px-2 flex items-center justify-between text-xs cursor-pointer"
        @click="site.activateModal('sumSubPasswordResetLoggedOutChangeNumber')"
      >
        {{ $t('change-mobile-number') }}
        <ChevronRightIcon
          class="w-4 stroke-2 text-dark-900 dark:text-light-50"
        />
      </div>
    </div>
    <div class="p-4 bg-base">
      <DesignSystemButton
        class="w-full justify-center"
        rounding="lg"
        type="tertiary"
        @click="emits('restart')"
      >
        {{ $t('back') }}
      </DesignSystemButton>
    </div>
  </div>
</template>
